import Waves from './WavesSvg';

export default Waves;